<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- 主要信息部分 -->
      <div class="footer-section main-section">
        <h3 class="footer-title">AlleleBC Database</h3>
        <p class="footer-desc">
          A comprehensive bioinformatics platform dedicated to allele-specific expression and methylation research, providing advanced genomic analysis tools and datasets.
        </p>
        <div class="footer-stats">
          <div class="stat-item">
            <span class="stat-number">1M+</span>
            <span class="stat-label">Variants</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">50K+</span>
            <span class="stat-label">Genes</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">2M+</span>
            <span class="stat-label">Regions</span>
          </div>
        </div>
      </div>

      <!-- 快速链接 -->
      <div class="footer-section">
        <h4 class="footer-subtitle">Quick Links</h4>
        <div class="footer-links">
          <router-link to="/search" class="footer-link">
            <el-icon><Search /></el-icon>
            Data Browser
          </router-link>
          <router-link to="/tools" class="footer-link">
            <el-icon><Tools /></el-icon>
            Analysis Tools
          </router-link>
          <router-link to="/help" class="footer-link">
            <el-icon><QuestionFilled /></el-icon>
            Help Center
          </router-link>
          <router-link to="/about" class="footer-link">
            <el-icon><InfoFilled /></el-icon>
            About Us
          </router-link>
        </div>
      </div>

      <!-- 研究团队信息 -->
      <div class="footer-section">
        <h4 class="footer-subtitle">Research Group</h4>
        <div class="institution-info">
          <p class="institution-name">Zhu Jiang Bioinformatics Research Group</p>
          <p class="department">Department of Medical Informatics</p>
          <p class="university">Harbin Medical University (Daqing Campus)</p>
          <div class="contact-info">
            <div class="contact-item">
              <el-icon><Message /></el-icon>
              <a href="mailto:contact@foxhank.top" class="contact-link">contact@foxhank.top</a>
            </div>
            <div class="contact-item">
              <el-icon><Location /></el-icon>
              <span>Daqing, Heilongjiang, China</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 资源和文档 -->
      <div class="footer-section">
        <h4 class="footer-subtitle">Resources</h4>
        <div class="footer-links">
          <a href="#" class="footer-link">
            <el-icon><Document /></el-icon>
            Documentation
          </a>
          <a href="#" class="footer-link">
            <el-icon><Download /></el-icon>
            Data Downloads
          </a>
          <a href="#" class="footer-link">
            <el-icon><Link /></el-icon>
            API Reference
          </a>
          <a href="#" class="footer-link">
            <el-icon><EditPen /></el-icon>
            Cite Us
          </a>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="copyright">
          <p>&copy; 2024 AlleleBC Database. All rights reserved.</p>
          <p class="powered-by">Powered by Zhu Jiang Bioinformatics Research Group</p>
        </div>
        <div class="footer-bottom-links">
          <router-link to="/about" class="footer-bottom-link">About</router-link>
          <a href="#" class="footer-bottom-link">Privacy Policy</a>
          <a href="#" class="footer-bottom-link">Terms of Use</a>
          <a href="#" class="footer-bottom-link">Contact</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {
  Search,
  Tools,
  QuestionFilled,
  InfoFilled,
  Message,
  Location,
  Document,
  Download,
  Link,
  EditPen
} from '@element-plus/icons-vue'

export default {
  name: 'Footer',
  components: {
    Search,
    Tools,
    QuestionFilled,
    InfoFilled,
    Message,
    Location,
    Document,
    Download,
    Link,
    EditPen
  }
}
</script>

<style scoped>
/* 页脚主容器 */
.footer {
  background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
  color: white;
  margin-top: 80px;
}

/* 页脚内容容器 */
.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 20px 40px;
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 1fr;
  gap: 40px;
  align-items: start;
}

/* 页脚区块 */
.footer-section {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 主要信息区块 */
.main-section {
  padding-right: 20px;
}

/* 页脚标题 */
.footer-title {
  font-size: 28px;
  margin-bottom: 16px;
  font-weight: 600;
  color: white;
}

/* 页脚描述 */
.footer-desc {
  opacity: 0.9;
  line-height: 1.8;
  margin-bottom: 24px;
  font-size: 15px;
}

/* 统计数据 */
.footer-stats {
  display: flex;
  gap: 24px;
  margin-top: 20px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  display: block;
  font-size: 24px;
  font-weight: 700;
  color: #fbbf24;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 13px;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* 子标题 */
.footer-subtitle {
  font-size: 18px;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
  font-weight: 600;
}

.footer-subtitle::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 3px;
  background: #fbbf24;
  border-radius: 2px;
}

/* 页脚链接 */
.footer-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-link {
  color: white;
  text-decoration: none;
  opacity: 0.85;
  transition: all 0.3s ease;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.footer-link:hover {
  opacity: 1;
  transform: translateX(8px);
  color: #fbbf24;
}

.footer-link .el-icon {
  font-size: 16px;
}

/* 机构信息 */
.institution-info {
  font-size: 14px;
  line-height: 1.6;
}

.institution-name {
  font-weight: 600;
  margin-bottom: 8px;
  color: #fbbf24;
  font-size: 15px;
}

.department,
.university {
  opacity: 0.9;
  margin-bottom: 6px;
}

.contact-info {
  margin-top: 16px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 13px;
}

.contact-item .el-icon {
  font-size: 14px;
  opacity: 0.8;
}

.contact-link {
  color: white;
  text-decoration: none;
  opacity: 0.9;
  transition: all 0.3s ease;
}

.contact-link:hover {
  opacity: 1;
  color: #fbbf24;
  text-decoration: underline;
}

/* 页脚底部 */
.footer-bottom {
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright {
  font-size: 13px;
  opacity: 0.8;
}

.powered-by {
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.7;
}

.footer-bottom-links {
  display: flex;
  gap: 20px;
}

.footer-bottom-link {
  color: white;
  text-decoration: none;
  font-size: 13px;
  opacity: 0.8;
  transition: all 0.3s ease;
  padding: 4px 8px;
}

.footer-bottom-link:hover {
  opacity: 1;
  text-decoration: underline;
  color: #fbbf24;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .footer-container {
    grid-template-columns: 1.8fr 1fr 1.1fr 1fr;
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .footer-container {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 40px;
    padding: 40px 20px 30px;
  }

  .main-section {
    padding-right: 0;
  }

  .footer-subtitle::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .footer-stats {
    justify-content: center;
  }

  .footer-bottom-content {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .footer-bottom-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 30px 15px 20px;
    gap: 30px;
  }

  .footer-title {
    font-size: 24px;
  }

  .footer-stats {
    flex-direction: column;
    gap: 16px;
  }

  .stat-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  .stat-number {
    font-size: 20px;
    margin-bottom: 0;
  }

  .footer-bottom-links {
    flex-direction: column;
    gap: 8px;
  }
}

/* Focus 状态样式 */
.footer-link:focus-visible,
.footer-bottom-link:focus-visible,
.contact-link:focus-visible {
  outline: 2px solid #fbbf24;
  outline-offset: 2px;
  border-radius: 4px;
}

/* 减少动画偏好支持 */
@media (prefers-reduced-motion: reduce) {
  .footer-section {
    animation: none;
  }

  .footer-link:hover {
    transform: none;
  }
}
</style>